import script from "./CustomRouterLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomRouterLink.vue?vue&type=script&setup=true&lang=ts"

import "./CustomRouterLink.vue?vue&type=style&index=0&id=6860dd72&lang=scss"

const __exports__ = script;

export default __exports__